import { createBrowserRouter } from 'react-router-dom';

import { App } from '@/components/App';
import { ItineraryStepElements } from '@/components/ItineraryStepElements/ItineraryStepElements';
import { StyledFlexColumn } from '@/layout/FlexLayout';
import { AccommodationPage } from '@/pages/Accommodation';
import { DayToDay } from '@/pages/DayToDay/DayToDay';
import { DestinationPage } from '@/pages/Destination';
import { ExcursionsPage } from '@/pages/Excursions/ExcursionsPage';
import { FlightsPage } from '@/pages/Flights';
import { OverviewPage } from '@/pages/Overview/OverviewPage';
import { PaymentComfirmed, PaymentPage } from '@/pages/Payment';
import { ProgramPage } from '@/pages/Program';
import { TravelPartyPage } from '@/pages/TravelParty/TravelParty';

// https://github.com/remix-run/react-router/issues/10787
export const Router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  {
    path: ':itineraryId?',
    element: <App />,
    children: [
      {
        path: '',
        element: <ItineraryStepElements />,
        children: [
          {
            path: '',
            element: <DestinationPage />,
          },
          {
            path: 'accommodaties',
            element: <AccommodationPage />,
          },
          {
            path: 'programma',
            element: <ProgramPage />,
          },
          {
            path: 'activiteiten',
            element: <ExcursionsPage />,
          },
          {
            path: 'overzicht',
            element: <OverviewPage />,
          },
          {
            path: 'vluchten',
            element: <FlightsPage />,
          },
          {
            path: 'reisgezelschap',
            element: <TravelPartyPage />,
          },
          { path: 'betaling', element: <PaymentPage /> },
        ],
      },
      { path: 'betaling-bevestigd', element: <PaymentComfirmed /> },
      {
        path: 'dag-tot-dag',
        element: <DayToDay />,
      },
      {
        path: '*',
        element: (
          <StyledFlexColumn alignItems="center" justifyContent="center" height="100%">
            <h1>404</h1>
            <h4>Pagina niet gevonden 🕵🏼‍</h4>
          </StyledFlexColumn>
        ),
      },
    ],
  },
]);
